import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { Garage } from '@/types/garage'

interface State {
    garage: Garage | null
    selectedRoutes: string[]
}

interface Actions {
    setGarage: (garage: Garage) => void
    setSelectedRoutes: (routes: string[]) => void
    clearGarage: () => void
}

export const useGarageStore = create<State & Actions>()(
    persist(
        (set) => ({
            garage: null,
            selectedRoutes: [],
            setGarage: (garage: Garage) => set({ garage }),
            setSelectedRoutes: (routes: string[]) => set({ selectedRoutes: routes }),
            clearGarage: () =>
                set({
                    garage: null,
                    selectedRoutes: [],
                }),
        }),
        {
            name: 'garage-storage',
        }
    )
)
